import './index_web.css';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { showErrorToast, showToast } from '../../../actions/app-actions-types';
import EventEmitter from '../../../utilities/EventEmitter';
import { getRouteObjByGame, isMatchInScheduled, isSmartPhone } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import I18n from '../../../utilities/locale';
import { useLink } from 'react-router-stack';
import { setMyContestList } from '../../../actions/fantasy-cricket-action-types';
import { setMyContestList as setFootballMyContestList } from '../../../actions/fantasy-football-action-types';
import constants from '../../../constants';
import MyTeamsListMWeb from './index_mWeb';
import MyTeamsListWeb from './index_web';

const MyTeamsList = () => {
  const navigate = useLink();
  const { item: matchItem = {}, fantasyMatchClick, gameType } = useGame();
  const { teamName = '' } = useSelector((state: any) => state.user);
  const {
    _id: matchId,
    joinedMatch,
    contestId,
    entryFee,
    bonusPercentage = 0,
    isTeamSwitch = false,
    competition = {},
    contestTeams = [],
    gameState = 0,
    status: matchStatus,
    maxTeamPerUser = 1,
    matchDelayed = false,
    tabType = 'FIXTURE'
  } = matchItem;

  const isScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });
  const { myTeamList: fantasyCricketMyTeamsList, playerList: fantasyCricketPlayerList } =
    useSelector((state: any) => state.fantasy_cricket);
  const { myTeamList: fantasyFootballMyTeamsList, playerList: fantasyFootballPlayerList } =
    useSelector((state: any) => state.fantasy_football);

  const { title = '' } = competition;
  const [addCashVisible, setAddCashVisible] = useState(false);
  const [myTeamList, setMyTeamList] = useState([] as any);
  const dispatch = useDispatch();

  const [contestConfirmModal, setContestConfirmModal] = useState(false);
  const [selectedTeamIdList, setSelectedTeamIdList] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [matchAllPlayersList, setMatchAllPlayerList] = useState([]);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const initSelectAllRef = useRef(() => {});

  const totalTeamsCount = myTeamList.length;

  useEffect(() => {
    getMyTeamList({});
    getAllPlayerListAPI();
    window.addEventListener('popstate', onClickBrowserBack);
    EventEmitter.on('teamUpdate', getMyTeamList);
    return () => {
      EventEmitter.off('teamUpdate', getMyTeamList);
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setContestConfirmModal(false);
    setAddCashVisible(false);
  };

  const getAllPlayerListAPI = () => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = fantasyCricketPlayerList[matchItem._id];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = fantasyFootballPlayerList[matchItem._id];
    }
    if (!error && result) {
      setMatchAllPlayerList(result);
      ///this is for calculate line up out
      let playingPlayersList = [];
      playingPlayersList = result.filter(
        (player: { playingEleven: boolean }) => player.playingEleven === true
      );
      setLineupsOut(playingPlayersList.length >= 15);
    } else {
      setError(true);
    }
  };
  const getMyTeamList = async ({ latestTeamData = { id: '' } } = {}) => {
    let result: any;
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = fantasyCricketMyTeamsList[matchItem._id];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = fantasyFootballMyTeamsList[matchItem._id];
    }

    if (!error && result) {
      const { id = '' } = latestTeamData;
      let isNotExistLatestTeam = _.findWhere(result, { id });
      if (id && !isNotExistLatestTeam) {
        result.push(latestTeamData);
      }
      result.sort((a: { sequence: number }, b: { sequence: number }) =>
        a.sequence > b.sequence ? 1 : -1
      );
      result = result.map((item: any) => {
        return { ...item, isSelected: false };
      });
      result.sort((a: any, b: any) => a.teamNumber - b.teamNumber);
      setMyTeamList(result);
      setError(false);
      initSelectAllRef.current();
    } else {
      setError(true);
    }
  };

  const onPressPreview = (teamData: any, teamNumber: any) => {
    navigate.push(getRouteObjByGame(gameType)['team_preview'], {
      teamData: { ...teamData, username: teamName },
      matchId,
      teamNumber,
      item: matchItem,
      fromCreateTeam: false,
      lineupsOut,
      matchAllPlayersList,
      gameType
    });
  };

  const onPressClone = (teamData: { players?: never[] | undefined }, teamNumber: any) => {
    const { players = [] } = teamData;
    let playerList: { id: any; playerId: any }[] = [];
    players.forEach((item: { id: any; playerId: any }) => {
      playerList.push({
        id: item.id,
        playerId: item.playerId
      });
    });

    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            selectedTeamPlayers: playerList,
            isEdit: false,
            teamNumber,
            isClone: true,
            joinedMatch,
            entryFee,
            contestId,
            teamData: {
              ...teamData,
              teamNumber: totalTeamsCount + 1
            },
            bonusPercentage,
            isTeamSwitch,
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const onPressEdit = (teamData: { players?: never[] | undefined }, teamNumber: any) => {
    const { players = [] } = teamData;
    let playerList: { id: any; playerId: any }[] = [];
    players.forEach((item: { id: any; playerId: any }) => {
      playerList.push({
        id: item.id,
        playerId: item.playerId
      });
    });

    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          selectedTeamPlayers: playerList,
          isEdit: true,
          teamNumber,
          joinedMatch,
          isClone: false,
          entryFee,
          contestId,
          teamData,
          bonusPercentage,
          isTeamSwitch,
          isFromMyTeam: true
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['create_team']);
  };

  // eslint-disable-next-line no-unused-vars
  const onPressJoinContest = () => {
    if (isScheduled) {
      setContestConfirmModal(true);
    } else {
      dispatch(showErrorToast(I18n.t('matchDeadlineFinishedSorryYouCannotJoinNow')));
    }
  };

  const joinContest = () => {
    if (isScheduled) {
      if (selectedTeamIdList.length > 0) {
        dispatch(showToast('Contest Joined Successfully'));
        if (gameType === constants.GameType.FANTASY_CRICKET) {
          setContestConfirmModal(false);
          dispatch(
            setMyContestList({
              contest: matchItem.contest,
              matchId: matchId
            })
          );
          navigate.push('/cricket');
        }
        if (gameType === constants.GameType.FANTASY_FOOTBALL) {
          setContestConfirmModal(false);

          dispatch(setFootballMyContestList({ contest: matchItem.contest, matchId: matchId }));
          navigate.push('/football');
        }
      } else {
        alert('Please select the team to join contest');
      }
    } else {
      dispatch(showErrorToast(I18n.t('matchDeadlineFinishedSorryYouCannotJoinNow')));
    }
  };

  const selectTeamByUser = (selectedTeamIndex = 0) => {
    if (maxTeamPerUser === 1 || isTeamSwitch) {
      myTeamList.forEach((_item: any, index: number) => {
        if (index === selectedTeamIndex) {
          myTeamList[index].isSelected = !myTeamList[index].isSelected;
        } else {
          myTeamList[index].isSelected = false;
        }
      });
      setForceUpdate(!forceUpdate);
    } else {
      let previousMyTeamList = myTeamList.filter(function (el: { isSelected: any }) {
        return el.isSelected;
      });
      if (previousMyTeamList.length < maxTeamPerUser || myTeamList[selectedTeamIndex].isSelected) {
        myTeamList[selectedTeamIndex].isSelected = !myTeamList[selectedTeamIndex].isSelected;
        setForceUpdate(!forceUpdate);
      } else {
        dispatch(
          showErrorToast(
            `maximum teams selected (${maxTeamPerUser}). Please deselect, to select others`
          )
        );
      }
    }
    setSelectTeamList();
  };

  const onPressAlreadyJoin = () => {
    dispatch(showToast(I18n.t('alreadyJoinedWithThisTeam')));
  };

  const setSelectTeamList = () => {
    let selectedMyTeamList = myTeamList.filter(function (el: { isSelected: any }) {
      return el.isSelected;
    });
    setSelectAll(selectedMyTeamList.length === myTeamList.length - contestTeams.length);
    setSelectedTeamIdList(selectedMyTeamList);
  };

  const onPressAddTeam = () => {
    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            isEdit: false,
            isClone: false,
            joinedMatch,
            entryFee,
            contestId,
            isTeamSwitch,
            selectedTeamPlayers: [],
            teamData: {
              teamNumber: totalTeamsCount + 1
            },
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const initSelectAll = () => {
    if (selectAll) {
      let count = maxTeamPerUser - contestTeams.length;
      myTeamList.forEach((item: { _id: any }, index: string | number) => {
        if (count <= 0) return true;
        const isJoined = _.findWhere(contestTeams, { matchTeamId: item._id });
        if (isJoined) {
          myTeamList[index].isSelected = false;
        } else {
          count--;
          myTeamList[index].isSelected = true;
        }
      });
      setSelectTeamList();
    }
  };

  initSelectAllRef.current = initSelectAll;

  const onPressSelectAll = () => {
    let count = maxTeamPerUser - contestTeams.length;
    let myTeamList: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      myTeamList = fantasyCricketMyTeamsList[matchItem._id];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      myTeamList = fantasyFootballMyTeamsList[matchItem._id];
    }
    myTeamList.forEach((item: { _id: any }, index: string | number) => {
      if (count <= 0) return true;
      const isJoined = _.findWhere(contestTeams, { matchTeamId: item._id });
      if (isJoined) {
        myTeamList[index].isSelected = false;
      } else {
        count--;
        myTeamList[index].isSelected = !selectAll;
      }
    });
    setSelectAll(!selectAll);
    setSelectTeamList();
  };

  const onPressDismissCashModal = () => {
    setAddCashVisible(false);
  };

  if (isSmartPhone) {
    return (
      <MyTeamsListMWeb
        matchItem={matchItem}
        totalTeamsCount={totalTeamsCount}
        gameState={gameState}
        gameType={gameType}
        matchStatus={matchStatus}
        myTeamList={myTeamList}
        selectTeamByUser={selectTeamByUser}
        onPressPreview={onPressPreview}
        onPressClone={onPressClone}
        onPressEdit={onPressEdit}
        onPressAlreadyJoin={onPressAlreadyJoin}
        lineupsOut={lineupsOut}
        title={title}
        matchAllPlayersList={matchAllPlayersList}
        contestTeams={contestTeams}
        tabType={tabType}
        onPressAddTeam={onPressAddTeam}
        onPressJoinContest={onPressJoinContest}
        selectedTeamIdList={selectedTeamIdList}
        isTeamSwitch={isTeamSwitch}
        contestConfirmModal={contestConfirmModal}
        addCashVisible={addCashVisible}
        joinContest={joinContest}
        bonusPercentage={bonusPercentage}
        setContestConfirmModal={setContestConfirmModal}
        onPressDismissCashModal={onPressDismissCashModal}
        onPressSelectAll={onPressSelectAll}
        initSelectAll={initSelectAll}
        selectAll={selectAll}
      />
    );
  } else {
    return (
      <MyTeamsListWeb
        matchItem={matchItem}
        totalTeamsCount={totalTeamsCount}
        gameState={gameState}
        gameType={gameType}
        matchStatus={matchStatus}
        myTeamList={myTeamList}
        selectTeamByUser={selectTeamByUser}
        onPressPreview={onPressPreview}
        onPressClone={onPressClone}
        onPressEdit={onPressEdit}
        onPressAlreadyJoin={onPressAlreadyJoin}
        lineupsOut={lineupsOut}
        title={title}
        matchAllPlayersList={matchAllPlayersList}
        contestTeams={contestTeams}
        tabType={tabType}
        onPressAddTeam={onPressAddTeam}
        onPressJoinContest={onPressJoinContest}
        selectedTeamIdList={selectedTeamIdList}
        isTeamSwitch={isTeamSwitch}
        contestConfirmModal={contestConfirmModal}
        addCashVisible={addCashVisible}
        joinContest={joinContest}
        bonusPercentage={bonusPercentage}
        setContestConfirmModal={setContestConfirmModal}
        onPressDismissCashModal={onPressDismissCashModal}
        onPressSelectAll={onPressSelectAll}
        initSelectAll={initSelectAll}
        selectAll={selectAll}
      />
    );
  }
};

export default MyTeamsList;
